import React, { useRef, useState, useEffect, memo} from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getCommonCodeGroupList } from '@store/actions/managementCodeAction';
import { showModal } from '@store/actions/commonAction';
import SatModal from '@components/common/satUI/SatModal';

const ManagementSystemCodeDetailPop = (props) => {
    const { isOpen, data, onClose, onSave, isModify=false } = props;

    const dispatch = useDispatch();
    const { allList } = useSelector(state => state.managementCodeReducer);
    
    const [detailCodeInfo, setDetailCodeInfo] = useState({
        cdTyId : '',
        cdVal : '',
        cmnCdNm : '',
        sortOrd : '',
        useYn : 'Y',
        rplceCdVal01 : '',
        rplceCdVal02 : '',
        rplceCdVal03 : '',
        fnlUpdDdtm : '',
        fnlUpdrEmpno : ''
    })

    useEffect(() => {
        setDetailCodeInfo({
            cdTyId : data.cdTyId === null ? '' : data.cdTyId,
            cdVal : data.cdVal === null ? '' : data.cdVal,
            cmnCdNm : data.cmnCdNm === null ? '' : data.cmnCdNm,
            sortOrd : data.sortOrd === null ? '' : data.sortOrd,
            useYn : data.useYn === null ? 'Y' : data.useYn,
            rplceCdVal01 : data.rplceCdVal01 === null ? '' : data.rplceCdVal01,
            rplceCdVal02 : data.rplceCdVal02 === null ? '' : data.rplceCdVal02,
            rplceCdVal03 : data.rplceCdVal03 === null ? '' : data.rplceCdVal03,
            fnlUpdDdtm : data.fnlUpdDdtm === null ? '' : data.fnlUpdDdtm,
            fnlUpdrEmpno : data.fnlUpdrEmpno === null ? '' : data.fnlUpdrEmpno,
        })
    }, [data])

    useEffect(()=>{
        if(isOpen){
            dispatch(getCommonCodeGroupList({
                compCd : '',
                keyWord : '',
                targetRow : 1,
            }))
        }
    }, [isOpen])
    const onChangeHandler = (e) => {
        const {name, value} = e.target;

        setDetailCodeInfo({
            ...detailCodeInfo,
            [name] : value
        })
    }
    const onOptionChangeHandler = (e) => {
        const {name, value} = e.target;

        setDetailCodeInfo({
            ...detailCodeInfo,
            [name] : value
        })
    }
    
    const onKeyupHandler = (e) => {
        const {value, name} = e.target;

        setDetailCodeInfo({
            ...detailCodeInfo,
            [name] : value.replace(/[^0-9.]/g, '')
        })
    }

    const onSaveHandler = () => {
        const {cdTyId, cdVal, cmnCdNm, sortOrd} = detailCodeInfo;

        if(cdTyId.trim() === '' || cdVal.trim() === '' || cmnCdNm.trim() === '' || sortOrd.toString().trim() === ''){
            dispatch(showModal({
                visible : true,
                type    : 'info',
                msg     : '필수값 입력을 확인해주세요.',
            }))
            return;
        }


        onSave(detailCodeInfo);
    }
    return (
        <>
            <SatModal visible={isOpen} type="newInfo">
                <h3 className='layer-tit2'>코드 등록/수정</h3>
                <div className='cont'>
                    <div className='modal-tbl'>
                        <table className='tbl-sty2'>
                            <colgroup>
                                <col width='25%;'/>
                                <col width='75%;'/>
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>그룹코드 유형</th>
                                    <td>
                                        <div className='data-area'>
                                            <div className='sel-group'>
                                                <select id='code-01' name='cdTyId' onChange={onOptionChangeHandler} value={detailCodeInfo.cdTyId} disabled={isModify}>
                                                    <option value=''>선택</option>
                                                    {allList.map((item, index)=>(
                                                        <option key={`code-option-${item.cdTyId}-${index}`} value={item.cdTyId}>{item.cdTyNm}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>코드값</th>
                                    <td>
                                        <div className='input-wrap'>
                                            <div className='input-area'>
                                                <input type='text' name='cdVal' id='code-02' placeholder='코드값을 입력하세요.' value={detailCodeInfo.cdVal} onChange={onChangeHandler} disabled={isModify}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>코드명</th>
                                    <td>
                                        <div className='input-wrap'>
                                            <div className='input-area'>
                                                <input type='text' name='cmnCdNm' id='code-03' placeholder='코드명을 입력하세요.' value={detailCodeInfo.cmnCdNm} onChange={onChangeHandler}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>코드순서</th>
                                    <td>
                                        <div className='input-wrap'>
                                            <div className='input-area'>
                                                <input type='text' name='sortOrd' id='code-04' placeholder='코드순서를 입력하세요.' value={detailCodeInfo.sortOrd} onChange={onChangeHandler} onKeyUp={onKeyupHandler}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사용여부</th>
                                    <td>
                                        <div className='check-box'>
                                            <div className='check-wrap'>
                                                <input type='radio' name='useYn' id='use01' checked={detailCodeInfo.useYn === '' || detailCodeInfo.useYn === 'Y'} value='Y' onChange={onChangeHandler}/>
                                                <label htmlFor='use01'>사용</label>
                                            </div>
                                            <div className='check-wrap mgl-10'>
                                                <input type='radio' name='useYn' id='use02' checked={detailCodeInfo.useYn === 'N'} value='N' onChange={onChangeHandler}/>
                                                <label htmlFor='use02'>미사용</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>대체코드값1</th>
                                    <td>
                                        <div className='input-wrap'>
                                            <div className='input-area'>
                                                <input type='text' name='rplceCdVal01' id='code-05' placeholder='대체코드값1을 입력하세요.' value={detailCodeInfo.rplceCdVal01} onChange={onChangeHandler}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>대체코드값2</th>
                                    <td>
                                        <div className='input-wrap'>
                                            <div className='input-area'>
                                                <input type='text' name='rplceCdVal02' id='code-06' placeholder='대체코드값2을 입력하세요.' value={detailCodeInfo.rplceCdVal02} onChange={onChangeHandler}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>대체코드값3</th>
                                    <td>
                                        <div className='input-wrap'>
                                            <div className='input-area'>
                                                <input type='text' name='rplceCdVal03' id='code-07' placeholder='대체코드값3을 입력하세요.' value={detailCodeInfo.rplceCdVal03} onChange={onChangeHandler}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록/수정일시</th>
                                    <td>
                                        <span className='txt'>{detailCodeInfo.fnlUpdDdtm}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록/수정ID</th>
                                    <td>
                                        <span className='txt'>{detailCodeInfo.fnlUpdrEmpno}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='layer-footer'>
                    <button className='btn-l btn-save' onClick={() => onSaveHandler()}>저장</button>
                </div>
                <button className='btn-layer-close modal-close' onClick={onClose}>창닫기</button>
            </SatModal>
        </>
    )
}

export default memo(ManagementSystemCodeDetailPop);